import { Question } from '../types/assessment';

export const anxietyQuestions: Question[] = [
  {
    id: 'gad7_intro',
    text: 'Over the last 2 weeks, how often have you been bothered by the following problems?',
    type: 'text',
    category: 'anxiety',
    subcategory: 'gad7',
    required: false,
    validationRules: []
  },
  {
    id: 'gad7_nervousness',
    text: 'Feeling nervous, anxious, or on edge',
    type: 'multiple-choice',
    category: 'anxiety',
    subcategory: 'gad7',
    required: true,
    options: [
      { value: 0, label: 'Not at all', score: 0 },
      { value: 1, label: 'Several days', score: 1 },
      { value: 2, label: 'More than half the days', score: 2 },
      { value: 3, label: 'Nearly every day', score: 3 }
    ]
  },
  {
    id: 'gad7_worry_control',
    text: 'Not being able to stop or control worrying',
    type: 'multiple-choice',
    category: 'anxiety',
    subcategory: 'gad7',
    required: true,
    options: [
      { value: 0, label: 'Not at all', score: 0 },
      { value: 1, label: 'Several days', score: 1 },
      { value: 2, label: 'More than half the days', score: 2 },
      { value: 3, label: 'Nearly every day', score: 3 }
    ]
  },
  {
    id: 'gad7_excessive_worry',
    text: 'Worrying too much about different things',
    type: 'multiple-choice',
    category: 'anxiety',
    subcategory: 'gad7',
    required: true,
    options: [
      { value: 0, label: 'Not at all', score: 0 },
      { value: 1, label: 'Several days', score: 1 },
      { value: 2, label: 'More than half the days', score: 2 },
      { value: 3, label: 'Nearly every day', score: 3 }
    ]
  },
  {
    id: 'gad7_trouble_relaxing',
    text: 'Trouble relaxing',
    type: 'multiple-choice',
    category: 'anxiety',
    subcategory: 'gad7',
    required: true,
    options: [
      { value: 0, label: 'Not at all', score: 0 },
      { value: 1, label: 'Several days', score: 1 },
      { value: 2, label: 'More than half the days', score: 2 },
      { value: 3, label: 'Nearly every day', score: 3 }
    ]
  },
  {
    id: 'gad7_restlessness',
    text: 'Being so restless that it is hard to sit still',
    type: 'multiple-choice',
    category: 'anxiety',
    subcategory: 'gad7',
    required: true,
    options: [
      { value: 0, label: 'Not at all', score: 0 },
      { value: 1, label: 'Several days', score: 1 },
      { value: 2, label: 'More than half the days', score: 2 },
      { value: 3, label: 'Nearly every day', score: 3 }
    ]
  },
  {
    id: 'gad7_irritability',
    text: 'Becoming easily annoyed or irritable',
    type: 'multiple-choice',
    category: 'anxiety',
    subcategory: 'gad7',
    required: true,
    options: [
      { value: 0, label: 'Not at all', score: 0 },
      { value: 1, label: 'Several days', score: 1 },
      { value: 2, label: 'More than half the days', score: 2 },
      { value: 3, label: 'Nearly every day', score: 3 }
    ]
  },
  {
    id: 'gad7_fear',
    text: 'Feeling afraid, as if something awful might happen',
    type: 'multiple-choice',
    category: 'anxiety',
    subcategory: 'gad7',
    required: true,
    options: [
      { value: 0, label: 'Not at all', score: 0 },
      { value: 1, label: 'Several days', score: 1 },
      { value: 2, label: 'More than half the days', score: 2 },
      { value: 3, label: 'Nearly every day', score: 3 }
    ]
  },
  // Additional anxiety-specific questions
  {
    id: 'anxiety_physical_symptoms',
    text: 'Which physical symptoms do you experience when anxious? (Select all that apply)',
    type: 'multi-select',
    category: 'anxiety',
    subcategory: 'physical',
    required: false,
    options: [
      { value: 'rapid-heartbeat', label: 'Rapid or pounding heartbeat' },
      { value: 'sweating', label: 'Sweating or hot flashes' },
      { value: 'trembling', label: 'Trembling or shaking' },
      { value: 'shortness-of-breath', label: 'Shortness of breath' },
      { value: 'chest-tightness', label: 'Chest tightness or pain' },
      { value: 'nausea', label: 'Nausea or stomach upset' },
      { value: 'dizziness', label: 'Dizziness or lightheadedness' },
      { value: 'muscle-tension', label: 'Muscle tension or aches' },
      { value: 'headaches', label: 'Headaches' },
      { value: 'fatigue', label: 'Fatigue or exhaustion' },
      { value: 'none', label: 'None of these' }
    ]
  },
  {
    id: 'anxiety_triggers',
    text: 'What situations or thoughts typically trigger your anxiety? (Select all that apply)',
    type: 'multi-select',
    category: 'anxiety',
    subcategory: 'triggers',
    required: false,
    options: [
      { value: 'social-situations', label: 'Social situations or interactions' },
      { value: 'work-performance', label: 'Work or academic performance' },
      { value: 'health-concerns', label: 'Health or medical concerns' },
      { value: 'financial-worries', label: 'Financial worries' },
      { value: 'family-relationships', label: 'Family or relationship issues' },
      { value: 'crowds', label: 'Crowds or busy places' },
      { value: 'uncertainty', label: 'Uncertainty or unpredictability' },
      { value: 'decision-making', label: 'Making decisions' },
      { value: 'conflict', label: 'Conflict or confrontation' },
      { value: 'being-judged', label: 'Fear of being judged or criticized' },
      { value: 'failure', label: 'Fear of failure or making mistakes' },
      { value: 'no-specific-trigger', label: 'No specific trigger' },
      { value: 'everything', label: 'Everything seems to cause anxiety' }
    ]
  },
  {
    id: 'panic_attacks',
    text: 'Have you experienced panic attacks (sudden episodes of intense fear with physical symptoms)?',
    type: 'multiple-choice',
    category: 'anxiety',
    subcategory: 'panic',
    required: true,
    options: [
      { value: 'never', label: 'Never' },
      { value: 'once-or-twice', label: 'Once or twice in my life' },
      { value: 'occasionally', label: 'Occasionally (few times per year)' },
      { value: 'monthly', label: 'About once a month' },
      { value: 'weekly', label: 'About once a week' },
      { value: 'daily', label: 'Nearly daily' }
    ]
  },
  {
    id: 'panic_attack_symptoms',
    text: 'If you have experienced panic attacks, which symptoms did you have? (Select all that apply)',
    type: 'multi-select',
    category: 'anxiety',
    subcategory: 'panic',
    required: false,
    condition: {
      dependsOn: 'panic_attacks',
      operator: 'not-equals',
      value: 'never'
    },
    options: [
      { value: 'heart-racing', label: 'Heart racing or pounding' },
      { value: 'chest-pain', label: 'Chest pain or discomfort' },
      { value: 'shortness-breath', label: 'Shortness of breath or smothering' },
      { value: 'choking', label: 'Feeling of choking' },
      { value: 'sweating', label: 'Sweating or chills' },
      { value: 'trembling', label: 'Trembling or shaking' },
      { value: 'nausea', label: 'Nausea or abdominal distress' },
      { value: 'dizziness', label: 'Dizziness or faintness' },
      { value: 'derealization', label: 'Feeling detached or unreal' },
      { value: 'fear-losing-control', label: 'Fear of losing control or going crazy' },
      { value: 'fear-dying', label: 'Fear of dying' },
      { value: 'numbness', label: 'Numbness or tingling' }
    ]
  },
  {
    id: 'avoidance_behaviors',
    text: 'Do you avoid certain situations because of anxiety?',
    type: 'multiple-choice',
    category: 'anxiety',
    subcategory: 'avoidance',
    required: true,
    options: [
      { value: 'never', label: 'Never avoid situations' },
      { value: 'rarely', label: 'Rarely avoid situations' },
      { value: 'sometimes', label: 'Sometimes avoid situations' },
      { value: 'often', label: 'Often avoid situations' },
      { value: 'always', label: 'Always or almost always avoid anxiety-provoking situations' }
    ]
  }
]; 